/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface TeamGroupModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class TeamGroupApiService extends SignalAdminResourceApiBase<TeamGroupModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'teamgroups');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<TeamGroupModel>> {
    return this.client.request<SignalAdminResourcePage<TeamGroupModel>>({
      method: 'GET',
      url: this.resourceUri('teamgroups'),
      params
    });
  }

  bulkSave(models: Partial<TeamGroupModel>[]): Observable<void> {
    return this.saveMany(models);
  }

  updateTeamToTeamGroup(teamGroupId: string, teamId: string, removeOnly: boolean): Observable<void> {
    return this.client.request<void>({
      method: 'POST',
      url: this.resourceUri(`teamgroups/${encodeURIComponent(teamGroupId)}/${encodeURIComponent(teamId)}`),
      params: {removeOnly},
      body: {}
    });
  }
}
